<template>
    <div class="tc-projects-list-container tc-thin-scrollbar">
        <div class="tc-projects-list-inner">
            <ProjectCard v-for="item in storeProjectStructure.cases"
                         :item="item"
                         :is-active="this.storeProjectStructure.selectedCaseId === item.id"
                         @select-tool-chest="selectCase(item.id)"
            />
        </div>
    </div>
</template>

<script>
import ProjectCard from '@/UI/LeftSidebar/Components/ProjectCard.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { presetsLib } from '@/Constants/presetsLib';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { saveCase } from '@/libs/saveCase';

export default {
    name: 'LeftSidebarProjects',
    setup() {
        const storeUI = useStoreUI();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storeProjectStructure = useStoreProjectStructure();
        return {
            storeUI,
            storeCaseConfiguration,
            storeProjectStructure,
        };
    },
    data() {
        return {
            casePresets: [ ...presetsLib ],
        };
    },
    computed: {},
    components: { ProjectCard },
    methods: {
        selectCase(id) {
            if (id === this.storeProjectStructure.selectedCaseId) {
                console.log('Шкаф уже выбран');
                return;
            }
            saveCase();
            const caseConfiguration = this.storeProjectStructure.getCaseDataById(id);
            this.storeProjectStructure.setSelectedCaseId(id);

            if (caseConfiguration) {
                this.storeCaseConfiguration.$patch(JSON.parse(JSON.stringify(caseConfiguration)));
            } else {
                console.warn('Конфигурация не найдена!');
            }
        },
        updateStoreCaseConfiguration(data) {
            this.storeCaseConfiguration.$patch(JSON.parse(JSON.stringify(data)));
        //     TODO load from window

        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/scrollbar";

.tc-projects-list-container {
    box-sizing: border-box;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow-y: auto;
    overflow-x: hidden;
}

.tc-projects-list-inner {
    display: flex;
    height: max-content;
    width: 100%;
    //overflow-y: hidden;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    padding-left: 15px;

    //padding: 0 15px;
}

</style>
